/*
  PDP media gallery — extracted from sections/gg-product-pdp.liquid so it ships as a cacheable,
  deferred asset instead of ~24KB of inline script. Liquid-derived values arrive through the
  [data-pdp-gallery-config] JSON block the section still renders.
*/
(function () {
  const configElement = document.querySelector('[data-pdp-gallery-config]');
  if (!configElement) return;

  let CONFIG;
  try {
    CONFIG = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  const MAIN_SIZES = CONFIG.mainSizes;
  const GRID_SIZES = CONFIG.gridSizes;
  const INITIAL_VARIANT_ID = CONFIG.initialVariantId;
  const INITIAL_PRODUCT_ID = CONFIG.initialProductId;
  const IS_COLUMNS_GALLERY = CONFIG.isColumnsGallery;
  const IS_ONE_COLUMN = CONFIG.isOneColumn;
  const HAS_VERTICAL_THUMBNAILS = CONFIG.hasVerticalThumbnails;
  const ALWAYS_USE_SLIDER = CONFIG.alwaysUseSlider;

  const MOBILE_MEDIA_QUERY = '(max-width: 768px)';
  const SRCSET_WIDTHS = [360, 540, 720, 900, 1080, 1296, 1512, 1800, 2200];
  const MAIN_MAX_WIDTH = 1512;
  const GRID_MAX_WIDTH = 1080;
  const ZOOM_MAX_WIDTH = 2400;
  const ZOOM_THUMBNAIL_WIDTH = 360;
  const MINIMUM_SLIDE_HEIGHT = 50;

  const ICONS = {
    close: '<svg viewBox="0 0 20 20"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    previous: '<svg viewBox="0 0 20 20"><path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    next: '<svg viewBox="0 0 20 20"><path d="M8 4l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>'
  };

  const sliderElement = document.getElementById('nugget-pdp-slider');
  const desktopGalleryElement = document.getElementById('nugget-pdp-desktop-gallery');
  const manifestElement = document.getElementById(CONFIG.manifestId);
  if (!sliderElement || !manifestElement) return;

  if (window.pdpMainSlider && window.pdpMainSlider.container !== sliderElement) {
    if (typeof window.pdpMainSlider.destroy === 'function') window.pdpMainSlider.destroy();
    window.imageDesktopDisplayTargetTypeSlider = undefined;
  }

  const mediaPrototype = {
    get imageTag() {
      return this.mediaType === 'video'
        ? this.videoHtml
        : buildImage(this, { sizes: MAIN_SIZES }).outerHTML;
    },
    get thumbnail() {
      return mediaUrl(this, 540);
    }
  };

  let galleryMedia = [];
  try {
    galleryMedia = JSON.parse(manifestElement.textContent).map(function (entry, index) {
      const record = Object.create(mediaPrototype);
      record.url = entry.url;
      record.width = entry.width || null;
      record.height = entry.height || null;
      record.alt = entry.alt || '';
      record.videoHtml = entry.videoHtml || '';
      record.mediaType = entry.type === 'video' ? 'video' : 'image';
      record.productId = entry.productId;
      record.variantId = entry.variantId;
      record.index = index;
      return record;
    });
  } catch (error) {
    galleryMedia = [];
  }

  window.pdpSlideImages = galleryMedia;
  window.pdpMainSlider = null;
  window.pdpMainThumbnailSlider = {};
  window.pdpMainDotsSlider = {};
  window.pdpMainThumbnailVertical = HAS_VERTICAL_THUMBNAILS;
  window.currentVariantId = INITIAL_VARIANT_ID;
  window.currentProductId = INITIAL_PRODUCT_ID;

  function mediaUrl(record, width) {
    const separator = record.url.indexOf('?') === -1 ? '?' : '&';
    return record.url + separator + 'width=' + width;
  }

  function mediaSrcset(record, maximumWidth) {
    const intrinsicWidth = record.width || maximumWidth;
    const candidates = [];
    for (const width of SRCSET_WIDTHS) {
      if (width > maximumWidth || width > intrinsicWidth) break;
      candidates.push(mediaUrl(record, width) + ' ' + width + 'w');
    }
    if (candidates.length === 0) {
      candidates.push(mediaUrl(record, intrinsicWidth) + ' ' + intrinsicWidth + 'w');
    }
    return candidates.join(', ');
  }

  function buildImage(record, options) {
    const maximumWidth = options.maxWidth || MAIN_MAX_WIDTH;
    const image = document.createElement('img');
    if (options.lazy) {
      image.loading = 'lazy';
      image.decoding = 'async';
    }
    image.alt = record.alt;
    if (record.width) image.width = record.width;
    if (record.height) image.height = record.height;
    image.className = 'js-open-gallery-viewer';
    image.sizes = options.sizes;
    image.srcset = mediaSrcset(record, maximumWidth);
    image.src = mediaUrl(record, Math.min(record.width || maximumWidth, maximumWidth));
    if (options.priority) image.setAttribute('fetchpriority', options.priority);
    return image;
  }

  function escapeAttribute(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  const variantRangeCache = {};

  function rangeForVariant(variantId) {
    const key = String(variantId);
    if (variantRangeCache[key]) return variantRangeCache[key];

    let minimum = null;
    let maximum = null;
    galleryMedia.forEach(function (record, index) {
      if (String(record.variantId) !== key) return;
      if (minimum === null) minimum = index;
      maximum = index;
    });

    variantRangeCache[key] = { min: minimum, max: maximum };
    return variantRangeCache[key];
  }

  const zoomImageCache = {};

  function zoomImagesForVariant(variantId) {
    const key = String(variantId);
    if (zoomImageCache[key]) return zoomImageCache[key];

    const images = [];
    const mediaIndexes = [];
    galleryMedia.forEach(function (record, index) {
      if (record.mediaType !== 'image' || String(record.variantId) !== key) return;
      mediaIndexes.push(index);
      images.push({
        zoomUrl: mediaUrl(record, Math.min(record.width || ZOOM_MAX_WIDTH, ZOOM_MAX_WIDTH)),
        thumbTag:
          '<img src="' + escapeAttribute(mediaUrl(record, ZOOM_THUMBNAIL_WIDTH)) +
          '" alt="' + escapeAttribute(record.alt) + '" loading="lazy" decoding="async">'
      });
    });

    zoomImageCache[key] = { images: images, mediaIndexes: mediaIndexes };
    return zoomImageCache[key];
  }

  function openZoomAtMediaIndex(mediaIndex) {
    const record = galleryMedia[mediaIndex];
    if (!record) return;
    if (typeof theme === 'undefined' || typeof theme.buildGalleryViewer !== 'function') return;

    const entry = zoomImagesForVariant(record.variantId);
    if (entry.images.length === 0) return;

    const position = Math.max(0, entry.mediaIndexes.indexOf(mediaIndex));
    theme.buildGalleryViewer({
      images: entry.images,
      currentImage: entry.images[position].zoomUrl,
      close: ICONS.close,
      prev: ICONS.previous,
      next: ICONS.next
    });
  }

  function bindZoom(container, shouldStopPropagation) {
    if (!container || container.dataset.zoomBound === '1') return;
    container.dataset.zoomBound = '1';

    container.addEventListener('click', function (event) {
      const image = event.target.closest('.js-open-gallery-viewer');
      if (!image) return;
      const holder = image.closest('[data-media-index]');
      if (!holder) return;

      event.preventDefault();
      if (shouldStopPropagation) event.stopPropagation();
      openZoomAtMediaIndex(parseInt(holder.dataset.mediaIndex, 10));
    });
  }

  function mountSlide(slideElement) {
    if (!slideElement || slideElement.dataset.mediaMounted === '1') return;
    const record = galleryMedia[parseInt(slideElement.dataset.mediaIndex, 10)];
    if (!record) return;

    slideElement.dataset.mediaMounted = '1';
    if (record.mediaType === 'video') {
      slideElement.insertAdjacentHTML('beforeend', record.videoHtml);
    } else {
      slideElement.appendChild(buildImage(record, { sizes: MAIN_SIZES, maxWidth: MAIN_MAX_WIDTH }));
    }
  }

  function syncSliderHeight(slider, index) {
    const slideElement = slider.slides[index];
    if (!slideElement) return;
    const image = slideElement.querySelector('img');
    if (!image) return;

    const applyHeight = function () {
      const height = image.getBoundingClientRect().height;
      if (height > MINIMUM_SLIDE_HEIGHT) {
        slider.container.style.height = Math.round(height) + 'px';
      }
    };

    if (image.complete && image.naturalHeight) {
      applyHeight();
    } else {
      image.addEventListener('load', applyHeight, { once: true });
    }
  }

  const navigationSliders = [];

  function isNavigationSlideVisible(slider, index) {
    const slideElement = slider.slides[index];
    if (!slideElement) return false;
    const containerRectangle = slider.container.getBoundingClientRect();
    const slideRectangle = slideElement.getBoundingClientRect();
    return slideRectangle.left >= containerRectangle.left
      && slideRectangle.right <= containerRectangle.right;
  }

  function syncNavigationSliders(localIndex) {
    navigationSliders.forEach(function (slider) {
      if (slider.container.style.display === 'none') return;

      slider.slides.forEach(function (slide) {
        slide.classList.remove('active');
      });
      if (slider.slides[localIndex]) slider.slides[localIndex].classList.add('active');

      if (!isNavigationSlideVisible(slider, localIndex)) {
        slider.moveToIdx(Math.min(slider.track.details.maxIdx, localIndex));
      }
    });
  }

  function navigationPlugin(slider) {
    function moveMainSliderTo(slideElement, index) {
      const mainSlider = window.pdpMainSlider;
      if (!mainSlider) return;

      if (typeof slideElement.dataset.sliderIndex === 'string') {
        mainSlider.localSlideIndex = index;
        mainSlider.moveToIdx(parseInt(slideElement.dataset.sliderIndex, 10));
      } else {
        mainSlider.moveToIdx(index);
      }
    }

    function slideIndexOf(slideElement) {
      return Array.prototype.indexOf.call(slider.slides, slideElement);
    }

    slider.on('created', function () {
      navigationSliders.push(slider);
      const activeSlide = slider.slides[slider.track.details.rel];
      if (activeSlide) activeSlide.classList.add('active');

      slider.container.addEventListener('click', function (event) {
        const slideElement = event.target.closest('.keen-slider__slide');
        if (!slideElement || !slider.container.contains(slideElement)) return;
        moveMainSliderTo(slideElement, slideIndexOf(slideElement));
      });

      slider.container.addEventListener('keydown', function (event) {
        const slideElement = event.target.closest('.keen-slider__slide');
        if (!slideElement || !slider.container.contains(slideElement)) return;
        const index = slideIndexOf(slideElement);

        if (event.key === 'Enter') {
          moveMainSliderTo(slideElement, index);
        } else if (event.key === 'ArrowRight' && index < slider.slides.length - 1) {
          slider.slides[index + 1].focus();
          slider.slides[index + 1].click();
        } else if (event.key === 'ArrowLeft' && index > 0) {
          slider.slides[index - 1].focus();
          slider.slides[index - 1].click();
        }
      });
    });
  }

  function ensureNavigationSliders(variantId) {
    if (typeof KeenSlider !== 'function') return;
    const key = String(variantId);

    const thumbnailsElement = document.querySelector(
      '[id^="nugget-pdp-slider-thumbnails-"][data-variant-id="' + key + '"]'
    );
    const dotsElement = document.querySelector(
      '[id^="nugget-pdp-slider-dots-"][data-variant-id="' + key + '"]'
    );

    if (thumbnailsElement && !window.pdpMainThumbnailSlider[thumbnailsElement.dataset.productId]) {
      const thumbnailOptions = {
        loop: false,
        initial: 0,
        slides: { perView: 5, spacing: 15 }
      };
      if (HAS_VERTICAL_THUMBNAILS) thumbnailOptions.vertical = true;
      window.pdpMainThumbnailSlider[thumbnailsElement.dataset.productId] =
        KeenSlider(thumbnailsElement, thumbnailOptions, [navigationPlugin]);
    }

    if (dotsElement && !window.pdpMainDotsSlider[dotsElement.dataset.productId]) {
      window.pdpMainDotsSlider[dotsElement.dataset.productId] = KeenSlider(dotsElement, {
        loop: false,
        initial: 0,
        drag: false,
        slides: { perView: 'auto', spacing: 0 }
      }, [navigationPlugin]);
    }
  }

  let previousButton = null;
  let nextButton = null;

  function setArrowVisibility(button, isVisible) {
    button.style.visibility = isVisible ? 'visible' : 'hidden';
    button.style.pointerEvents = isVisible ? 'auto' : 'none';
  }

  function findArrowButtons() {
    if (!previousButton) previousButton = document.querySelector('.slider-nav.prev');
    if (!nextButton) nextButton = document.querySelector('.slider-nav.next');
    return Boolean(previousButton && nextButton);
  }

  function updateArrows() {
    const mainSlider = window.pdpMainSlider;
    if (!mainSlider || !mainSlider.track) return;
    if (!findArrowButtons()) return;

    const currentIndex = mainSlider.track.details.rel;
    const range = rangeForVariant(window.currentVariantId || INITIAL_VARIANT_ID);
    setArrowVisibility(previousButton, !(currentIndex <= range.min));
    setArrowVisibility(nextButton, !(currentIndex >= range.max));
  }

  function bindArrows() {
    if (!findArrowButtons() || previousButton.dataset.navBound === '1') return;
    previousButton.dataset.navBound = '1';
    nextButton.dataset.navBound = '1';

    previousButton.addEventListener('click', function () {
      const mainSlider = window.pdpMainSlider;
      if (!mainSlider) return;
      if (mainSlider.track.details.rel === 0) {
        mainSlider.moveToIdx(mainSlider.track.details.maxIdx);
      } else {
        mainSlider.prev();
      }
    });

    nextButton.addEventListener('click', function () {
      const mainSlider = window.pdpMainSlider;
      if (!mainSlider) return;
      if (mainSlider.track.details.rel === mainSlider.track.details.maxIdx) {
        mainSlider.moveToIdx(0);
      } else {
        mainSlider.next();
      }
    });
  }

  function handleMainSliderSettled() {
    const mainSlider = window.pdpMainSlider;
    if (!mainSlider || !mainSlider.track) return;

    const index = mainSlider.track.details.rel;
    mountSlide(mainSlider.slides[index]);
    syncSliderHeight(mainSlider, index);
    updateArrows();
  }

  function handleMainSliderAnimationStarted(mainSlider) {
    const targetIndex = mainSlider.animator.targetIdx || 0;
    const slideElement = mainSlider.slides[targetIndex];
    mountSlide(slideElement);

    const localIndex = slideElement && typeof slideElement.dataset.sliderLocalIndex === 'string'
      ? parseInt(slideElement.dataset.sliderLocalIndex, 10)
      : mainSlider.track.absToRel(targetIndex);
    syncNavigationSliders(localIndex);
  }

  function handleMainSliderDragStarted(mainSlider) {
    const index = mainSlider.track.details.rel;
    mountSlide(mainSlider.slides[index + 1]);
    mountSlide(mainSlider.slides[index - 1]);
  }

  window.activatePdpMainSlider = function (variantId) {
    if (variantId == null) variantId = INITIAL_VARIANT_ID;
    window.currentVariantId = variantId;
    if (typeof KeenSlider !== 'function') return;

    sliderElement.classList.remove('js-hidden');
    const sliderContainer = document.querySelector('.slider-image-container');
    if (sliderContainer) sliderContainer.classList.remove('js-hidden');

    const range = rangeForVariant(variantId);
    const initialIndex = range.min === null ? 0 : range.min;
    const options = { loop: false };
    if (range.min !== null && range.max !== null) {
      options.range = { min: range.min, max: range.max };
    }

    if (window.pdpMainSlider) {
      window.pdpMainSlider.update(options, initialIndex);
    } else {
      options.initial = initialIndex;
      sliderElement.classList.remove('pdp-slider--pending');
      window.pdpMainSlider = new KeenSlider(sliderElement, options);
      window.pdpMainSlider.on('animationStarted', handleMainSliderAnimationStarted);
      window.pdpMainSlider.on('animationEnded', handleMainSliderSettled);
      window.pdpMainSlider.on('dragStarted', handleMainSliderDragStarted);
      bindArrows();
      bindZoom(sliderElement, true);
    }

    ensureNavigationSliders(variantId);
    handleMainSliderSettled();
  };

  function removePdpMainSlider() {
    if (window.pdpMainSlider && typeof window.pdpMainSlider.destroy === 'function') {
      window.pdpMainSlider.destroy();
    }
    window.pdpMainSlider = null;

    const sliderContainer = document.querySelector('.slider-image-container');
    if (sliderContainer) sliderContainer.classList.add('js-hidden');
    sliderElement.classList.add('js-hidden');
    return true;
  }

  window.activateStandardImageGallery = function (variantId) {
    if (!desktopGalleryElement) return false;
    if (variantId == null) variantId = INITIAL_VARIANT_ID;
    window.currentVariantId = variantId;
    desktopGalleryElement.classList.remove('js-hidden');

    if (desktopGalleryElement.dataset.renderedVariant !== String(variantId)) {
      const outerElement = document.createElement('div');
      outerElement.className = 'desktop-gallery' + (IS_ONE_COLUMN ? ' desktop-gallery-one-column' : '');
      let isFirst = true;

      galleryMedia.forEach(function (record, index) {
        if (String(record.variantId) !== String(variantId)) return;

        const itemElement = document.createElement('div');
        itemElement.className = 'desktop-gallery-item' + (isFirst ? ' desktop-gallery-item-first' : '');
        itemElement.dataset.mediaIndex = index;

        if (IS_COLUMNS_GALLERY) {
          if (record.mediaType === 'video') {
            itemElement.innerHTML = record.videoHtml;
          } else {
            itemElement.appendChild(buildImage(record, {
              sizes: isFirst ? MAIN_SIZES : GRID_SIZES,
              maxWidth: isFirst ? MAIN_MAX_WIDTH : GRID_MAX_WIDTH,
              lazy: !isFirst,
              priority: isFirst ? 'high' : null
            }));
          }
        }

        outerElement.appendChild(itemElement);
        isFirst = false;
      });

      desktopGalleryElement.replaceChildren(outerElement);
      desktopGalleryElement.dataset.renderedVariant = String(variantId);
    }

    mountPendingVideos();
    bindZoom(desktopGalleryElement, false);
    return true;
  };

  function mountPendingVideos() {
    if (!desktopGalleryElement) return;
    desktopGalleryElement.querySelectorAll('[data-pending-video]').forEach(function (itemElement) {
      const record = galleryMedia[parseInt(itemElement.dataset.mediaIndex, 10)];
      delete itemElement.dataset.pendingVideo;
      if (record && record.mediaType === 'video') {
        itemElement.innerHTML = record.videoHtml;
      }
    });
  }

  function removeStandardImageGallery() {
    if (!desktopGalleryElement) return false;
    desktopGalleryElement.classList.add('js-hidden');
    return true;
  }

  window.updateArrows = updateArrows;
  window.removePdpMainSlider = removePdpMainSlider;
  window.removeStandardImageGallery = removeStandardImageGallery;

  function start() {
    if (ALWAYS_USE_SLIDER) {
      window.imageDesktopDisplayTargetTypeSlider = true;
      window.activatePdpMainSlider(window.currentVariantId);
      return;
    }

    const mobileMediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

    const applyBreakpoint = function (isMobile) {
      if (!isMobile && window.imageDesktopDisplayTargetTypeSlider !== false) {
        window.imageDesktopDisplayTargetTypeSlider = false;
        removePdpMainSlider();
        window.activateStandardImageGallery(window.currentVariantId);
      } else if (isMobile && window.imageDesktopDisplayTargetTypeSlider !== true) {
        window.imageDesktopDisplayTargetTypeSlider = true;
        removeStandardImageGallery();
        window.activatePdpMainSlider(window.currentVariantId);
      }
    };

    applyBreakpoint(mobileMediaQuery.matches);

    const handleBreakpointChange = function (event) {
      applyBreakpoint(event.matches);
    };

    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mobileMediaQuery.addListener(handleBreakpointChange);
    }
  }

  let hasStarted = false;

  function startOnce() {
    if (hasStarted) return;
    hasStarted = true;
    start();
  }

  if (typeof KeenSlider === 'function' && document.readyState !== 'loading') {
    startOnce();
  } else {
    document.addEventListener('DOMContentLoaded', startOnce, { once: true });
    window.addEventListener('load', startOnce, { once: true });
  }
}());
